import getReducer from '@admin/utils/get_reducer'
import { moveItem } from './utils'

export default getReducer([
  { name: 'items', type: 'array', default: [] },
  { name: 'test_item', type: 'var', default: null },
  { handle: 'ADD_ITEMS', handler: (state, action) => ({
    ...state,
    items: [
      ...state.items,
      action.item
    ],
    test_item: null
  }) },
  { handle: 'MOVE_ITEM', handler: (state, action) => ({
    ...state,
    items: moveItem(state.items, action.sourceCode, action.targetParent, action.targetIndex)
  }) }
])